module.exports = __webpack_public_path__ + "static/media/silder_fix_1.4d1c8ae3.jpg";